import React, {Component} from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import {withRouter} from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Spinner from "react-bootstrap/Spinner";

import classes from './ExerciseDetails.module.css';
import {InfoOutlined} from "@material-ui/icons";

import apiUrl from "../../shared/config";
import {Helmet} from "react-helmet";
import UserButton from "../UI/UserButton/UserButton";
import {formatParagraphs} from "../../utils/utils";

class ExerciseDetails extends Component {

    state = {
        exercise: null
    };

    componentDidMount() {
        // console.log('ID: ', this.props.id);
        if (this.props.id && (!this.props.urlId || this.props.id === this.props.urlId)) {
            // When the ExerciseDetails mount, only fetch the exercise if the props contains an id, and either the URL
            // doesn't contain an id or the URL contains the same id as the selected id. Otherwise, fetching the
            // exercise will be handled on update
            axios.get(apiUrl +'Exercises/getExerciseById?exercise_id=' + this.props.id + (this.props.token ?  '&token=' + this.props.token : ''))
                .then(response => {
                    this.setState({exercise: response.data});
                    window.scrollTo({
                        top: document.getElementById('exercise-details').offsetTop,
                        behavior: 'smooth'
                    })
                });


            // axios.get(apiUrl + 'Exercises/getExerciseById?exercise_id=' + this.props.match.params.exerciseId )
            //     .then(response => {
            //         this.setState({ patternExerciseDetails: response.data });
            //     })
            //     .catch(error => {
            //         console.log(error);
            //     });



        }
        else if (this.state.exercise && this.props.id === null) {
            this.setState({exercise: null});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.id  && this.props.id !== prevProps.id) {
            if (!this.state.exercise || (this.state.exercise && this.state.exercise.exercise_id !== this.props.id)) {
                // console.log('ID: ', this.props.id, 'EXERCISE: ', this.state.exercise);
                axios.get(apiUrl +'Exercises/getExerciseById?exercise_id=' + this.props.id + (this.props.token ?  '&token=' + this.props.token : ''))
                    .then(response => {
                        this.setState({exercise: response.data});
                        window.scrollTo({
                            top: document.getElementById('exercise-details').offsetTop,
                            behavior: 'smooth'
                        })
                    });
            }
        }
        else if (this.state.exercise && this.props.id === null) {
            this.setState({exercise: null});
        }
    }

    // should need to pass token for auth
    deletePostHandler = () => {
        axios.get(apiUrl +'Exercises/delete?exercise_id=' + this.props.id + "&token="+ this.props.token)
            .then(response => {
                this.props.closeExerciseDetails(null);
                this.props.exerciseSelected(null);
                console.log("Delete Success")
            }).catch(() => console.log("Delete Failed"));
    };

    editExerciseHandler = (selectedExerciseId) => {
        this.props.editExercise(selectedExerciseId);
        this.props.closeExerciseDetails(null);
    };

    render () {
        let exercise = <div className="d-flex justify-content-sm-center">
            <div className="alert alert-secondary text-center select-alert" role="alert">
                Please select a Exercise to view.
            </div>
        </div>;
        if (this.props.id && !this.state.pattern && this.state.exerciseDetailsOpen) {
            exercise = <div className="d-flex justify-content-sm-center loading-alert">
                <Button variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <span> Loading...</span>
                </Button>{' '}
            </div>;
        }

        if (this.state.exercise && this.props.exerciseDetailsOpen) {


            let exercise_step_count = 0;
            const exercise_steps = this.state.exercise.steps.map((exercise_step) => {
                exercise_step_count++;
                return (
                    <React.Fragment key={exercise_step_count}>
                        <dd className="col-xl-8">{exercise_step.exercise_step_id + '. ' + exercise_step.exercise_step}
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={"info_link_"+exercise_step_count}
                                placement='top'
                                overlay={
                                    <Popover id='game-deleloper-description'>
                                        <Popover.Title as="h3">Exercise Step {exercise_step.exercise_step_id} Notes</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {exercise_step.exercise_step_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )
            });

            const exercise_steps_wrapper = () => {
                let info_links = '';
                if (this.state.exercise.steps.length > 0) {
                    info_links = (<React.Fragment key="info-links">
                        <dt className="col-xl-4">Exercise Steps:</dt>
                        {exercise_steps}
                    </React.Fragment>);
                }

                return info_links;
            };







            const shareText = 'Pattern Language for Game Design — Pattern Exercises: ' + this.state.exercise.exercise_name;







            //const site = String(game_image).replace("http://", '').replace("https://", '').split('/');
            exercise = (
                <div className="card pattern-details">
                    <Helmet>
                        <title>{shareText}</title>
                    </Helmet>
                    <h1 className="card-header">{this.state.exercise.exercise_name}</h1>
                    <div className="card-body">
                        <div className="card-text">
                            <Container>
                                <Row className={classes.description}>

                                    <Col className="col-xl-12" style={{whiteSpace: "pre-wrap"}}>
                                        {formatParagraphs(this.state.exercise.exercise_description)}
                                    </Col>
                                </Row>

                                <Row>

                                    <Col className="col-lg-12 col-xl-12">
                                        <dl className="row">
                                            {exercise_steps_wrapper()}
                                        </dl>
                                    </Col>


                                </Row>

                                <Row>
                                    <Col className="col-sm">
                                        {}
                                    </Col>
                                </Row>
                                <br />
                            </Container>
                        </div>
                    </div>
                </div>
            );
        }

        return exercise;
    }
}

export default withRouter(ExerciseDetails);